import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Icon } from "../icon";
import { useTranslation } from "../i18n";
import { useConfig } from "../_util/config-context";
export var LoadingTip = React.forwardRef(function LoadingTip(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var t = useTranslation();
    var hideIcon = props.hideIcon, className = props.className, _a = props.loadingText, loadingText = _a === void 0 ? t.loadingText : _a, restProps = __rest(props, ["hideIcon", "className", "loadingText"]);
    return (React.createElement("span", __assign({ ref: ref, className: classNames(classPrefix + "-action-state", className) }, restProps),
        !hideIcon && React.createElement(Icon, { type: "loading", className: classPrefix + "-mr-2n" }),
        typeof loadingText === "string" ? (React.createElement("span", { className: classPrefix + "-action-state__text", title: loadingText }, loadingText)) : (loadingText)));
});
LoadingTip.displayName = "LoadingTip";
//# sourceMappingURL=LoadingTip.js.map